module.exports = __webpack_public_path__ + "odstraneni-tetovaze_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/odstraneni-tetovaze_2_after_tn.jpg
// module id = 1423
// module chunks = 0